import { Components, Theme } from '@mui/material';

const MuiPaginationItem: Components<Theme>['MuiPaginationItem'] = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      ...(ownerState.color === 'standard' && {
        '&.Mui-selected': {
          backgroundColor: theme.palette.grey[900],
          color: theme.palette.common.white,
          '&:hover': {
            backgroundColor: theme.palette.grey[900],
          },
        },
      }),
    }),
  },
};

export default MuiPaginationItem;
